import { themeV2 } from '@features/executive-report/domain/theme-v2';
import { TextProps, TextPropsTextConfig } from '@features/powerpoint';

export const buildNavbarText = <T extends string>(
  sections: readonly T[],
  activeSection: T
): TextProps => {
  return {
    text: sections.flatMap((section): TextPropsTextConfig[] => {
      const isActive = section === activeSection;
      return [
        {
          text: section.toLocaleUpperCase(),
          options: isActive
            ? { color: themeV2.colors.inmarketGreen, bold: true }
            : {},
        },
        {
          text: '     ',
        },
      ];
    }),
    options: {
      fontSize: 10.5,
      h: 0.34,
      w: 12.67,
      x: 0.33,
      y: 0.25,
    },
  };
};
